
import { Component } from 'vue-facing-decorator'
import { ListViewVue } from '@/common/BaseVue'

@Component({})
export default class extends ListViewVue {
  listType = "router";

  getCondition() {
    return { name: "", isDefault: "" }
  }

  async getList() {
    let data: any = { ...this.mesureData };
    /** 空值别往后端送：name='' 没有意义，isDefault 转出来是非法值 */
    ['name', 'isDefault'].forEach((key) => {
      if (data[key] === '' || data[key] === null || data[key] === undefined) {
        delete data[key];
      }
    });
    return this.$post("/manager/warehouse/list", data);
  }

  /** 省市区和详细地址分开存的，拼起来才是一条完整地址 */
  fullAddress(row) {
    let parts = [row.province, row.city, row.county, row.address].filter((item) => item);
    return parts.length ? parts.join(" ") : "-";
  }

  resetFilter() {
    this.find(this.getCondition())
  }

  async delRow(id) {
    await this.$postError("/manager/warehouse/delete", {
      id,
    });
    this.$success("删除成功");
    this.refresh();
  }

  /**
   * 设为默认走的是「编辑」接口，而 EditWarehouseDto 里的字段都是必填，
   * 所以得把整条仓库信息一起回传，只把 isDefault 改成 true。
   * 不直接 {...row}：列表行上还有 storeId、createTime 这些 DTO 里没有的字段
   */
  async setDefault(row) {
    await this.$confirm("是否设置为默认发货仓库？");
    await this.$postError("/manager/warehouse/edit", {
      id: row.id,
      name: row.name,
      isDefault: true,
      senderName: row.senderName,
      senderMobile: row.senderMobile,
      province: row.province,
      city: row.city,
      county: row.county,
      address: row.address,
    });
    this.$success("设置成功");
    this.refresh();
  }

  /**
   * 按 path 跳而不是 name：name 取的是后端菜单的 aliasName，
   * 这边只拿得到菜单里配的路径，写死 name 就得跟后端始终保持一致
   */
  operat(id?) {
    let query = id ? { id } : undefined;
    this.$goto({
      path: "/shop/order/warehouse/operat",
      query,
    });
  }
}
